import { UserManager, User } from 'oidc-client-ts';
import { authConfig } from './auth.config';
import { BehaviorSubject } from 'rxjs';
import { DecodedToken } from '../models/decoded-token';
//aasas
export class AuthService {
  private userManager = new UserManager(authConfig);
  private user: User | null = null;

    private userSubject = new BehaviorSubject<any | null>(null);
    currentUser$ = this.userSubject.asObservable();

  constructor() {
    this.loadUser();
    this.setupEvents();
  }

  // 🔄 Load user from storage
  private async loadUser() {
    this.user = await this.userManager.getUser();
    console.log('-----------User---------------')
    console.log(this.user);
    console.log('-----------User---------------')

  }

  async login() {
    await this.userManager.signinRedirect();
  }

  async handleCallback() {
    this.user = await this.userManager.signinRedirectCallback();
    return this.user;
  }

  async logout() {
    this.user = null;
    localStorage.removeItem('accessAndRole')
    localStorage.removeItem('userId')
    await this.userManager.signoutRedirect();
  }

  // ✅ FIXED: now works
  getAccessToken() {
    return this.user?.access_token || null;
  }
  getIdToken() {
    return this.user?.id_token || null;
  }

  getRefreshToken() {
    return this.user?.refresh_token || null;
  }

  isLoggedIn() {
    return this.user && !this.user.expired;
  }

  getCurrentUser(): any {
    const profileData = localStorage.getItem('profile') as string;
    const parsedJson = JSON.parse(profileData);
  return {
    user: this.user,
    id: parsedJson.userId,
    userName: this.user?.profile?.given_name || '',
    UserAttendanceId: parsedJson.userAttendanceId,
    access: parsedJson.access,
    roles: parsedJson.roles ?? parsedJson.role ?? [],
    profilePicture:parsedJson.picture
  };
}

getCurrentUserSync(): any {
  return {
    user: this.user,
    id:this.user,
    userName: this.user?.profile?.name || '',
    access: []
  };
}

  async getUser() {
    this.user = await this.userManager.getUser();
    return this.user;
  }

  // 🔁 Setup expiry listeners
  private setupEvents() {
    this.userManager.events.addAccessTokenExpiring(async () => {
      console.log('Token expiring...');
      await this.refreshToken();
    });

    this.userManager.events.addAccessTokenExpired(async () => {
      console.log('Token expired...');
      await this.refreshToken();
    });

    // Optional: sync user on load
    this.userManager.events.addUserLoaded((user) => {
      this.user = user;
    });
  }

  // 🔄 Proper refresh using OIDC
  private async refreshToken() {
    try {
      const user = await this.userManager.signinSilent();
      this.user = user;
      console.log('✅ Token refreshed via silent renew');
    } catch (err) {
      console.warn('❌ Silent refresh failed → re-login', err);
      await this.login();
    }
  }
  
}
